import { initGrowthBook } from '../../../services/GrowthBook/GrowthBookService';

initGrowthBook();
